import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'dropdown-check',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class DropdownCheck extends Vue {

    @Prop()
    public subjectClassificationFramework: any;
    @Prop()
    public selectedDefaultCheckbox: any;
    @Prop()
    public valueId: any;
    @Prop()
    public selectedFramework: any;
    @Prop()
    public valueSubject: any;

    public frameWorkCheck = [];

    private onSelectFrameworkComponent(subValue: any, catValueId: any) {
        const frameworkIndex = this.valueSubject.frameworks.findIndex((item: any) => {
            return item.standard_framework_id === subValue.standard_framework_id &&
                item.taxonomy_subject_id === subValue.taxonomy_subject_id;
        });
        if (subValue.is_default) {
            return;
        } else {
            const isCheckedACtive = this.valueSubject.frameworks[frameworkIndex].isChecked ? false : true;
            this.$set(this.valueSubject.frameworks[frameworkIndex], 'isChecked', isCheckedACtive);
            if (subValue.isChecked) {
                this.selectedFramework.push(subValue);
            } else {
                const selectedIndex = this.selectedFramework.findIndex((item: any) => {
                    return item.standard_framework_id === subValue.standard_framework_id &&
                        item.taxonomy_subject_id === subValue.taxonomy_subject_id;
                });
                if (selectedIndex !== -1) {
                    this.selectedFramework.splice(selectedIndex, 1);
                }
            }
        }

        this.$emit('onSelectFramework', subValue, catValueId, this.valueSubject);
        this.frameWorkCheck = this.selectedFramework.map((items: any) => {
            return items.taxonomy_subject_id;
        });
    }

    private onSelectDefaultCheckbox(subValue: any, catValueId: any) {
        for (const iterator of this.subjectClassificationFramework) {
            iterator.is_default = false;
        }
        const frameworkIndex = this.valueSubject.frameworks.findIndex((item: any) => {
            return item.standard_framework_id === subValue.standard_framework_id &&
                item.taxonomy_subject_id === subValue.taxonomy_subject_id;
        });
        const isCheckedACtive = this.valueSubject.frameworks[frameworkIndex].is_default ? false : true;
        this.$set(this.valueSubject.frameworks[frameworkIndex], 'is_default', isCheckedACtive);
        this.selectedDefaultCheckbox = subValue;
        this.$emit('onSelectDefaultCheckbox', subValue, catValueId, this.valueSubject);
        this.frameWorkCheck = this.selectedFramework.map((items: any) => {
            return items.taxonomy_subject_id;
        });
    }


    private created() {
        this.frameWorkCheck = this.selectedFramework.map((items: any) => {
            return items.taxonomy_subject_id;
        });
    }
}
